import { render, staticRenderFns } from "./Papers.vue?vue&type=template&id=7193e3eb"
import script from "./Papers.vue?vue&type=script&lang=js"
export * from "./Papers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports